import {useQuery} from 'react-query';

import {getAvailableLoanTypes} from './getAvailableLoanTypes';
import {availableLoanTypeResponse} from './types';

const useGetAvailableLoanTypes = (enabled: boolean) => {
  const {data, isLoading, refetch} = useQuery<availableLoanTypeResponse>(
    ['get-available-loan-types'],
    getAvailableLoanTypes,
    {
      enabled: enabled,
    },
  );
  return {data, isLoading, refetch};
};

export default useGetAvailableLoanTypes;
